// Gespräche / Conversations (Agent 7D, Runde 7): Verlauf mit Gesprächskarten und Player, Live Calls und Telefonie-Qualität
// (T48, T49, Z-09). Die Route ist `/gespraeche/*`:
//   /gespraeche               Verlauf (History)
//   /gespraeche/live          Live Calls und Meetings von heute
//   /gespraeche/qualitaet     Telefonie-Qualität (Recht „Telefonie verwalten“)
//   /gespraeche/anruf/:id     ein einzelnes Gespräch mit Leitungsqualität
// Die Bausteine liegen in `src/gespraeche/`, der Client in `src/api/gespraeche.ts`, die Routen stehen in API.md 22.4. Den Player stellt
// `components/AufnahmePlayer.tsx` (Besitzer 7B). Die Anrufliste unter Aktivitäten bekommt ihre Spalte „Aufnahme“ mit demselben Player.
import { Navigate, Route, Routes } from "react-router-dom";
import { GespraechDetail } from "../gespraeche/GespraechDetail";
import { GespraecheStart } from "../gespraeche/GespraecheStart";
import { LiveGespraeche } from "../gespraeche/LiveGespraeche";
import { Qualitaet } from "../gespraeche/Qualitaet";

export default function Gespraeche() {
  return (
    <Routes>
      <Route index element={<GespraecheStart />} />
      <Route path="live" element={<LiveGespraeche />} />
      <Route path="qualitaet" element={<Qualitaet />} />
      <Route path="anruf/:callId" element={<GespraechDetail />} />
      <Route path="*" element={<Navigate to="/gespraeche" replace />} />
    </Routes>
  );
}
